/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Slide,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { styles } from "../pages/withdraw/theme";
import AppScreenLoader from "./AppScreenLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  checkBankSeenStatus,
  connectBank,
  deleteBank,
  getPockytConnectedBanks,
  showMessageBar,
} from "../store/actions";
import {
  ADDITIONAL_BANK_MODES,
  BANK_ITEM_LIST_ACTION,
  BANK_MODE,
  COMPLIANCE_FAILURE,
  COMPLIANCE_IN_PROGRESS,
  COMPLIANCE_INCOMPLETE,
  MESSAGE_BAR_TYPES,
  paymentOptions,
  STATUS_MODE,
  TRANSFER_MODE,
} from "../utils/constants";
import {
  CheckOutlined,
  CheckCircle,
  InfoOutlined,
  RadioButtonUnchecked,
  Close,
  Delete,
  ReportProblem,
} from "@mui/icons-material";
import { isMaskedEmail, maskDigits } from "../utils";
import { Trans, useTranslation } from "react-i18next";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AppDialogHalfScreen from "./AppDialogHalfScreen";
import { useNavigate } from "react-router-dom";
import AppButton from "./AppButton";
import AppToolTip from "./AppTooltip";
import {
  getComplianceStatus,
  getFiatBanks,
  logEvent,
  validateBankAccount,
} from "../store/api";
import { EVENTS } from "../utils/events";
import AdditionalPaymentForm from "./AdditionalPaymentForm";
import { getFromValueSelector } from "../utils/selectorHelpers";
import AppPopupWindow from "./AppPopupWindow";
export default function AppBankList({
  active,
  setActive,
  bankList,
  bank,
  setBank,
  mode = TRANSFER_MODE,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [openConfirmation, setOpenConfirmation] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  const [additionalFormMode, setAdditionalFormMode] = useState(ADDITIONAL_BANK_MODES.update);
  const formValues = useSelector(getFromValueSelector);
  const [complianceStatus, setComplianceStatus] = useState();
  const [showTNC, setShowTNC] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [pollingStartTime, setPollingStartTime] = useState(null);
  const handleConfirmOpen = () => {
    setAnchorEl(null);
    setOpenConfirmation(true);
  };
  const handleConfirmClose = (val) => {
    setOpenConfirmation(false);
    if (val) {
      logEvent({
        current: EVENTS.BANK_TRANSFER.BANK_DELETE_CANCEL,
        activity: EVENTS.BANK_TRANSFER.BANK_DELETE_CANCEL,
        meta: {},
      });
    }
  };
  const [selectedBank, setSelectedBank] = React.useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [bankForm, setBankForm] = React.useState(null);
  const [formData, setFormData] = React.useState(null);
  const openListOption = Boolean(anchorEl);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getPockytConnectedBanks());
    setAdditionalFormMode(ADDITIONAL_BANK_MODES.update);
    checkComplianceOfBanks();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const checkBankCompatibility = async (value) => {
    try {
      setLoading(true);
      const data = await validateBankAccount(value);
      if (data?.result?.status === 0
      ) {
        const obj1 = {}; 
        Object.keys(bankForm || {}).forEach((key) => {
          const fields = bankForm[key];
          const obj = fields.map((field) => {
            const fields = formValues?.fields;
            if (fields?.[field.name] && field?.acceptedValues?.length <= 0) {
              // eslint-disable-next-line eqeqeq
              field.acceptedValues = fields?.[field.name];
            }
            return field;
          });
          obj1[key] = obj;
        });
        setBankForm(value);
        setFormData(data?.result);
        setLoading(false);
      } else if (
        data?.result?.status === 1 &&
        !(
          data?.result?.bankDetail?.filter((v) => v.isRequired)?.length ||
          data?.result?.personalDetail?.filter((v) => v.isRequired)?.length
        )
      ) {
        const banks = await getFiatBanks();
        const bank = banks.result.find(
          (v) => v.accountTag === value.accountTag
        );
        setBank(bank);
        navigateToSummary(bank);
        return;
      } else if (data?.result?.status === -2) {
        setLoading(false);
        dispatch(getPockytConnectedBanks());
        dispatch(
          showMessageBar(
            MESSAGE_BAR_TYPES.SUCCESS,
            "Bank verification pending."
          )
        );
      } else {
        setLoading(false);
        dispatch(
          showMessageBar(
            MESSAGE_BAR_TYPES.ERROR,
            "Unable to process transfer with this bank."
          )
        );
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        showMessageBar(
          MESSAGE_BAR_TYPES.ERROR,
          "Unable to process transfer with this bank."
        )
      );
    }
  };

  const navigateToSummary = (value) => {
    setBank(value);
    setActive(active + 2, "summary");
    logEvent({
      current: EVENTS.BANK_TRANSFER.BANK_SELECTED,
      activity: EVENTS.BANK_TRANSFER.BANK_SELECTED,
      meta: {
        ...value,
      },
    });
  };

  const handleBankSelect = async (value) => {
    // 1 compatibility ok
    if (value.disabled) {
      return;
    }
    // if (value?.service === [paymentOptions.bd, paymentOptions.masspay].indexOf) {
    // check compliance status and show form
    setFormData(null);
    if (value?.subStatus !== 0) {
      try {
        setLoading(true);
        const complianceResponse = await getComplianceStatus(
          value.country,
          value?.destinationRecordId,
          value.service
        );
        // mostly the status is 1
        setComplianceStatus(complianceResponse?.result);
        if (complianceResponse?.result?.status === -6) {
          // open form and return
          setBankForm(value);
          setAdditionalFormMode(ADDITIONAL_BANK_MODES.add);
          setFormData(complianceResponse?.result);
          setLoading(false);
          return;
        }
        if (complianceResponse?.result?.status === COMPLIANCE_FAILURE) {
          // failed
          setLoading(false);
          return;
        }
        if (complianceResponse?.result?.status === COMPLIANCE_INCOMPLETE) {
          // incomplete
          setShowTNC(
            [COMPLIANCE_INCOMPLETE].indexOf(
              complianceResponse?.result?.status
            ) > -1
          );
          setLoading(false);
          return;
        }
        if (complianceResponse?.result?.status === COMPLIANCE_IN_PROGRESS) {
          // in progress
          setShowTNC(false);
          setLoading(false);
          dispatch(
            showMessageBar(
              MESSAGE_BAR_TYPES.ERROR,
              "Bank verification pending."
            )
          );
          return;
        }
        setLoading(false);
      } catch (err) {
        dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
        setLoading(false);
        return;
      }
    }
    // }
    if (value?.subStatus === 1) {
      navigateToSummary(value);
      return;
    }
    //-2  validation pending
    if (
      value?.subStatus === -2 ||
      value?.subStatus === 0 ||
      value?.subStatus === -1
    ) {
      checkBankCompatibility(value); //
    }
  };
  const handleAddBank = () => {
    logEvent({
      current: EVENTS.BANK_TRANSFER.ADD_BANK_SELECTED,
      activity: EVENTS.BANK_TRANSFER.ADD_BANK_SELECTED,
      meta: {},
    });
    dispatch(connectBank(true));
  };
  const dashboardHandleAddBank = () => {
    handleAddBank();
    navigate("/bank");
  };
  const handleCloseListOption = () => {
    setAnchorEl(null);
  };
  const checkComplianceOfBanks = () => {
    if (bankList && bankList?.length) {
      bankList.forEach((bank) => {
        if (bank.service === paymentOptions["type-5"]) {
          getComplianceStatus(bank.country, null, bank.service);
        }
      });
      dispatch(getPockytConnectedBanks());
    }
  };
  if (!bankList || !bankList.length || loading) {
    return <AppScreenLoader />;
  }
  function isAddBankEnabled() {
    if (
      mode !== STATUS_MODE &&
      bankList &&
      Array.isArray(bankList) &&
      fiatService?.enableFiat
    ) {
      return true;
    }
    return false;
  }
  function isBankPending() {
    let showAddABank = true;
    for (let index = 0; index < bankList.length; index++) {
      const bank = bankList[index];
      if (Number(bank.status) === 0) {
        showAddABank = false;
      }
    }
    return showAddABank;
  }
  function isActionPending() {
    let showAddABank = true;
    for (let index = 0; index < bankList.length; index++) {
      const bank = bankList[index];
      if (Number(bank.subStatus) === -3) {
        showAddABank = false;
      }
    }
    return showAddABank;
  }
  function handleDeleteBank() {
    handleConfirmOpen();
  }
  const dismiss = async (bank) => {
    dispatch(checkBankSeenStatus({ accountTag: bank.accountTag }));
  };

  async function startCompliancePolling(item) {
    try {
      // Check if 3 minutes have passed
      if (pollingStartTime) {
        const elapsed = Date.now() - pollingStartTime;
        if (elapsed >= 180000) {
          // 3 minutes = 180000ms
          clearInterval(intervalId);
          setIntervalId(null);
          setPollingStartTime(null);
          dispatch(getPockytConnectedBanks());
          return;
        }
      }

      const complianceResponse = await getComplianceStatus(
        item.country,
        item?.destinationRecordId,
        item.service
      );
      if (complianceResponse?.result?.status === -5) {
        // Show TOS popup
        // setComplianceStatus(complianceResponse?.result);
        // setShowTNC(true);
      } else {
        // Status changed, stop polling and call getFiatBanks
        clearInterval(intervalId);
        setIntervalId(null);
        setPollingStartTime(null);
        dispatch(getPockytConnectedBanks());
        await getFiatBanks();
      }
    } catch (err) {
      dispatch(
        showMessageBar(
          MESSAGE_BAR_TYPES.ERROR,
          err?.response?.data?.message ||
            err.message ||
            "Unable to fetch compliance status."
        )
      );
      setLoading(false);
    }
  }
  const handleStatusMinusThreeAction = async (item) => {
    try {
      setLoading(true);
      const complianceResponse = await getComplianceStatus(
        item.country,
        item?.destinationRecordId,
        item.service
      );
      if (complianceResponse?.result?.status === -5) {
        // Show TOS popup
        setComplianceStatus(complianceResponse?.result);
        setShowTNC(true);
        // Start polling with 3 minute timeout
        const startTime = Date.now();
        setPollingStartTime(startTime);
        const newIntervalId = setInterval(() => startCompliancePolling(item), 10000); // 10 seconds
        setIntervalId(newIntervalId);
        // Set timeout to stop after 3 minutes
        setTimeout(() => {
          clearInterval(newIntervalId);
          setIntervalId((currentId) => {
            if (currentId === newIntervalId) {
              return null;
            }
            return currentId;
          });
          setPollingStartTime(null);
          dispatch(getPockytConnectedBanks());
        }, 60000); // 3 minutes = 180000ms
      }
      setLoading(false);
    } catch (err) {
      dispatch(
        showMessageBar(
          MESSAGE_BAR_TYPES.ERROR,
          err?.response?.data?.message ||
            err.message ||
            "Unable to fetch compliance status."
        )
      );
      setLoading(false);
    }
  };
  function confirmBankDelete() {
    dispatch(
      deleteBank({
        accountTag: selectedBank.accountTag,
        service: selectedBank.service,
      })
    );
    logEvent({
      current: EVENTS.BANK_TRANSFER.BANK_DELETE,
      activity: EVENTS.BANK_TRANSFER.BANK_DELETE,
      meta: {
        bankId: selectedBank.accountTag,
      },
    });
  }
  function handleListOptionClick(event, item) {
    setAnchorEl(event.currentTarget);
    setSelectedBank(item);
  }
  function ConfirmationModal(props) {
    const { item } = props;
    return (
      <AppDialogHalfScreen
        show={openConfirmation}
        onChangeShow={(val) => handleConfirmClose()}
        title={t("confirmDelete")}
        subtitle={t("areYouSureBank")}
      >
        <DialogActions
          sx={{
            marginTop: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            autoFocus
            onClick={() => handleConfirmClose(true)}
            sx={{
              textTransform: "capitalize",
            }}
          >
            {t("Cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              confirmBankDelete(item);
              handleConfirmClose();
            }}
            sx={{
              color: "#F8FAFF",
              textTransform: "capitalize",
              borderRadius: "8px",
              ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
            }}
          >
            {t("confirm")}
          </Button>
        </DialogActions>
      </AppDialogHalfScreen>
    );
  }
  if (
    bankForm &&
    formData &&
    Object.keys(bankForm).length &&
    Object.keys(formData).length > 0
  ) {
    return (
      <AdditionalPaymentForm
        setActive={setActive}
        bankForm={{
          bankDetail:
            Array.isArray(formData?.bankDetail) &&
            formData.bankDetail.length > 0
              ? formData.bankDetail
              : formData?.newBankConfiguration?.bankDetail,
          personalDetail:
            Array.isArray(formData?.personalDetail) &&
            formData.personalDetail.length > 0
              ? formData.personalDetail
              : formData?.newBankConfiguration?.personalDetail,
        }}
        mode={mode}
        setBank={setBank}
        bankData={bankForm}
        additionalFormMode={additionalFormMode}
        destinationRecords={formData}
      />
    );
  }
  return (
    <Slide in={true} direction="left">
      <Paper
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          overflow: "hidden",
        }}
      >
        <AppPopupWindow
          src={complianceStatus?.tosLink}
          title={t("sigin.TnC")}
          show={showTNC}
          setShow={setShowTNC}
          width={500}
          height={700}
        />
        {mode === TRANSFER_MODE && (
          <>
            <Box marginBottom={2}>
              <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={14} fontFamily={"Manrope"}>
                  {t("transferMethod")}:
                </Typography>
                <Typography fontSize={14} fontFamily={"Manrope"}>
                  {t("bankDeposit")}
                </Typography>
              </Box>
            </Box>
            <Typography
              fontSize={14}
              fontWeight={400}
              fontFamily={"Manrope"}
              marginBottom={1}
            >
              {t("addOrEditBank")}
            </Typography>
            {!bank && (
              <Box
                display="flex"
                alignItems="center"
                gap={0.8}
                marginBottom={2}
              >
                <InfoOutlined sx={{ fontSize: 16, color: "#0088F5" }} />
                <Typography fontSize={14} color="#0088F5">
                  Select the bank account where you want to receive your funds
                </Typography>
              </Box>
            )}
          </>
        )}
        {/* <Divider sx={{ marginTop: 2, marginBottom: 4 }} /> */}
        <List
          sx={{
            maxHeight: mode === TRANSFER_MODE ? "32vh" : "60vh",
            overflowY: "auto",
            padding: 1,
          }}
        >
          {bankList?.map((item, index) => {
            const selectedKey = bank?.id || bank?.accountTag;
            const itemKey = item?.id || item?.accountTag;
            const isSelected = !!selectedKey && selectedKey === itemKey;
            const isTransferReady = mode === TRANSFER_MODE && Number(item.status) === 1 && Number(item.subStatus) !== -2;
            const canSelectBank = isTransferReady && !item?.disabled;
            return (
            <ListItem
              key={item.accountTag + index}
              sx={{
                ...(isSelected ? styles.selected : {}),
                ...(isTransferReady
                  ? {
                      ...styles.bankListTransferItem,
                      ...(isSelected ? styles.bankListTransferItemSelected : {}),
                      alignItems: isSelected ? "flex-start" : "center",
                    }
                  : {}),
              }}
              disabled={mode === TRANSFER_MODE && item?.disabled}
              // disabled={fiatService?.services?.indexOf(item.service) <= -1 && mode === TRANSFER_MODE}
              onClick={() =>
                canSelectBank
                  ? setBank(item)
                  : null
              }
            >
              {(Number(item.status) === 0 || item.subStatus === -2) && (
                <>
                  <ListItemAvatar>
                    <CircularProgress style={{ width: 30, height: 30 }} />
                  </ListItemAvatar>
                  <span>
                    <ListItemText
                      primary={`${t("bankAccount")}   ${maskDigits(
                        item.accountNumber
                      )} (${item.currency})`}
                      secondary={t("pockyt.pending")}
                    />
                    <Typography sx={{ fontSize: "10px" }}>
                      {t("pockyt.pendingDesc")}
                    </Typography>
                  </span>
                </>
              )}
              {Number(item.status) === -1 && Number(item.subStatus) !== -2 && (
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  width={"100%"}
                >
                  <ListItemAvatar>
                    <ReportProblem style={{ width: 30, height: 30 }} />
                  </ListItemAvatar>
                  <Box width={"100%"}>
                    <Box>
                      <ListItemText
                        primary={`${t("bankAccount")}   ${maskDigits(
                          item.accountNumber
                        )} (${item.currency})`}
                        secondary={
                          mode === STATUS_MODE ? "" : t("bank.failedDesctr")
                        }
                      />
                      {mode === STATUS_MODE ? (
                        <Typography
                          variant="subtitle2"
                          textAlign={"left"}
                          data-i18n={`[html]bank.failedDesc`}
                          onClick={
                            mode === STATUS_MODE && Number(item.status) === -1
                              ? () => dashboardHandleAddBank(item)
                              : null
                          }
                          sx={{
                            "& span": {
                              color: "#1d8beb",
                            },
                          }}
                        >
                          <Trans
                            components={{
                              a: <span></span>,
                            }}
                          >
                            {t("bank.failedDesc")}
                          </Trans>
                        </Typography>
                      ) : null}
                    </Box>
                  </Box>
                  {mode === STATUS_MODE ? (
                    <IconButton
                      aria-label="tracker"
                      aria-describedby="bank_dismiss_icon_click"
                      onClick={() => dismiss(item)}
                      sx={{
                        padding: 1,
                        position: "relative",
                        background: "transparent",
                        alignSelf: "flex-start",
                      }}
                    >
                      <Close
                        aria-label="tracker"
                        aria-describedby="bank_dismiss_icon_click"
                      />
                    </IconButton>
                  ) : (
                    <></>
                  )}
                </Box>
              )}

              {Number(item.status) === -3 && (
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  width={"100%"}
                >
                  <ListItemAvatar>
                    <ReportProblem style={{ width: 30, height: 30 }} />
                  </ListItemAvatar>
                  <Box width={"100%"}>
                    <ListItemText
                      primary={`${t("bankAccount")}   ${maskDigits(
                        item.accountNumber
                      )} (${item.currency})`}
                    />
                    <Typography sx={{ fontSize: "10px" }}>
                      {t("actionRequired")}
                    </Typography>
                  </Box>
                  {item.country &&
                    item.service &&
                    Number(item.status) ===  -3 && (
                      <AppToolTip
                        title={t("pleaseAcceptTermOfServiceToGetThisBankAccountVerified")}
                        arrow
                        enterTouchDelay={0}
                      >
                        <Button
                          aria-label="check compliance"
                          aria-describedby="compliance_check_icon_click"
                          onClick={() => handleStatusMinusThreeAction(item)}
                          sx={{
                            position: "relative",
                            background: "transparent",
                            backgroundColor: "#0088F5",
                            fontSize: "12px",
                            padding: "5px 0 !important",
                            color: "#F8F8F8",
                            width: 120,
                            textTransform: "capitalize",
                          }}
                        >
                          {t("checkCompliance")}
                        </Button>
                      </AppToolTip>
                    )}
                </Box>
              )}

              {Number(item.status) === 1 && Number(item.subStatus) !== -2 && (
                <>
                  <ListItemAvatar sx={{ minWidth: 42, alignSelf: "center" }}>
                    {mode === TRANSFER_MODE ? (
                      isSelected ? (
                        <CheckCircle style={{ width: 30, height: 30, color: "#F8FAFF" }} />
                      ) : (
                        <RadioButtonUnchecked style={{ width: 30, height: 30, color: "#B5DFFF" }} />
                      )
                    ) : (
                      <CheckOutlined style={{ width: 30, height: 30 }} />
                    )}
                  </ListItemAvatar>
                  <Box width="100%">
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      width="100%"
                    >
                      <ListItemText
                        primary={`${t("bankAccount")} ${
                          mode === STATUS_MODE ? maskDigits(item.accountNumber) : ""
                        } (${item.currency})`}
                        secondary={
                          item.disabled && mode === TRANSFER_MODE
                            ? t("bankUnsupported")
                            : mode === STATUS_MODE
                            ? t("pockyt.successDesc")
                            : `${
                                isMaskedEmail(item.accountNumber)
                                  ? t("go.bankAccountEmail")
                                  : " "
                              } ${maskDigits(item.accountNumber)}`
                        }
                      />
                      {mode === TRANSFER_MODE && (
                        <Box sx={{ ...styles.bankListVerifiedBadge, display: "flex", alignItems: "center", gap: 0.5 }}>
                          <CheckCircle sx={{ fontSize: 18, color: "#0ECF72" }} />
                          {t("Verified")}
                        </Box>
                      )}
                    </Box>
                    {mode === TRANSFER_MODE && isSelected && (
                      <>
                        <Divider sx={styles.bankListSelectedDivider} />
                        <Box display="flex" alignItems="center" gap={0.8}>
                          <CheckOutlined sx={{ fontSize: 16, color: "#F8FAFF" }} />
                          <Typography sx={styles.bankListSelectedText}>
                            {t("This account is selected for transfer")}
                          </Typography>
                        </Box>
                      </>
                    )}
                  </Box>
                  {mode === STATUS_MODE ? (
                    <IconButton
                      aria-label="tracker"
                      aria-describedby="bank_dismiss_icon_click"
                      onClick={() => dismiss(item)}
                      sx={{
                        padding: 1,
                        position: "relative",
                        background: "transparent",
                      }}
                    >
                      <Close
                        aria-label="tracker"
                        aria-describedby="bank_dismiss_icon_click"
                      />
                    </IconButton>
                  ) : (
                    <></>
                  )}
                </>
              )}

              {mode === BANK_MODE &&
                (item.status === -1 || item.status === 1) &&
                Number(item.subStatus) !== -2 && (
                  <IconButton
                    aria-label="tracker"
                    aria-describedby="more_icon_click"
                    onClick={(e) => handleListOptionClick(e, item)}
                  >
                    <MoreVertIcon
                      aria-label="tracker"
                      aria-describedby="more_icon_click"
                    />
                  </IconButton>
                )}
              {/* {(fiatService?.services?.indexOf(item.service) <= -1 && mode === TRANSFER_MODE) && <Typography>{t("disabled")}</Typography>} */}
            </ListItem>
          )})}
        </List>
        {/* keep menu outside of loop as it automatically anchors itself to the calling element */}
        <Menu
          anchorEl={anchorEl}
          open={openListOption}
          onClose={handleCloseListOption}
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "#023662",
            },
          }}
        >
          {BANK_ITEM_LIST_ACTION.map((option, index) => (
            <MenuItem key={`${index}`} onClick={() => handleDeleteBank()}>
              <ListItemIcon>
                <Delete />
              </ListItemIcon>
              <Typography>{t("delete")}</Typography>
            </MenuItem>
          ))}
        </Menu>
        {mode === TRANSFER_MODE && (
          <Box marginTop={2}>
            <Tooltip
              title={!bank || bank?.disabled ? "Select a bank account to continue." : ""}
              placement="top"
              arrow
              componentsProps={{
                tooltip: { sx: styles.continueTooltip },
                arrow: { sx: styles.continueTooltipArrow },
              }}
            >
              <Box sx={{ cursor: !bank || bank?.disabled ? "not-allowed" : "pointer" }}>
                <span>
                  <AppButton
                    title={t("loginPage.continue")}
                    buttontheme="light"
                    disabled={!bank || bank?.disabled}
                    sx={{
                      "&.Mui-disabled": {
                        cursor: "not-allowed",
                        pointerEvents: "auto",
                      },
                    }}
                    onClick={() => {
                      if (bank && !bank?.disabled) {
                        handleBankSelect(bank);
                      }
                    }}
                  />
                </span>
              </Box>
            </Tooltip>
          </Box>
        )}
        {/* !bankList.filter((v) => v.status === 0).length    */}
        {/* allow addition of multiple banks even when pending */}
        {isAddBankEnabled() && isBankPending() && isActionPending() && (
          <Box>
            <Divider sx={{ marginTop: 3, marginBottom: 3 }}>OR</Divider>
            <AppButton onClick={handleAddBank} title={t("addBankAccount")} />
          </Box>
        )}
        {!isAddBankEnabled() && mode === TRANSFER_MODE && (
          <Typography marginTop={1}>{t("bankDisabled")}</Typography>
        )}
        <ConfirmationModal item={selectedBank} />
      </Paper>
    </Slide>
  );
}
